import { render, staticRenderFns } from "./Translations.vue?vue&type=template&id=31a648ae"
import script from "./Translations.vue?vue&type=script&lang=js"
export * from "./Translations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports